<div class="flex flex-col">
  <div class="grid grid-cols-2 gap-4 items-center portal-toolbar">
    <div>
      <span *ngIf="!addingNote" class="font-semibold">Notes</span>
      <div *ngIf="addingNote" class="flex flex-col md:flex-row gap-1 portal-detail-row">
        <span class="font-semibold">Add</span>
        <span class="font-semibold">Note</span>
      </div>
    </div>

    <div class="gap-2 flex justify-self-end items-center portal-actions">
      <button type="button" *ngIf="!addingNote"
              mat-button color="primary" (click)="toggleNoteForm(true)">Add</button>

      <button type="button" *ngIf="!addingNote"
              mat-button color="primary" (click)="getNotes(!includeArchived)">{{includeArchived? 'Hide Archived' : 'Show Archived'}}</button>

      <button type="button" *ngIf="addingNote && text.length > 0"
              mat-button color="primary" (click)="createNote()">Save</button>

      <button type="button" *ngIf="addingNote"
              mat-button color="warn" (click)="toggleNoteForm(false)">Cancel</button>
    </div>
  </div>

  <div class="flex flex-col" *ngIf="!addingNote">
    <mtx-grid [data]="notes"
              [columns]="columns"
              [cellTemplate]="{text: noteTpl, dateCreated: dateCreatedTpl, archive: archiveTpl}"
              [columnResizable]="true"
              [cellSelectable]="false"
              [pageSizeOptions]="[5,10, 25]">
    </mtx-grid>
  </div>

  <div class="flex flex-row portal-field-grid" *ngIf="addingNote">
    <mat-form-field class="w-full">
      <textarea matInput placeholder="Notes" type="text" rows="10" [(ngModel)]="text"></textarea>
    </mat-form-field>
  </div>
</div>

<ng-template #noteTpl let-row let-index="index" let-col="colDef">
  <mat-form-field class="w-full">
    <textarea matInput rows="1" [value]="row.text" readonly></textarea>
  </mat-form-field>
</ng-template>

<ng-template #dateCreatedTpl let-row let-index="index" let-col="colDef">
  <span>{{row.dateCreated | date}}</span>
</ng-template>

<ng-template #archiveTpl let-row let-index="index" let-col="colDef">
  <button type="button"
          mat-icon-button [color]="row.archived? 'primary' : 'warn'"
          (click)="archiveNote(row, !row.archived)"
          [matTooltip]="row.archived? 'Un-Archive Note' : 'Archive Note'"
          matTooltipShowDelay="500" matTooltipHideDelay="200">
    <mat-icon *ngIf="!row.archived">archive</mat-icon>
    <mat-icon *ngIf="row.archived">unarchive</mat-icon>
  </button>
</ng-template>
